module.exports = __webpack_public_path__ + "assets/backlist.28dbdee5.svg";